<template>
  <div class="year-container">
    <span v-if="!yearMonth" style="padding-right: 10px">
      年份选择
    </span>
    <span v-if="yearMonth" style="padding-right: 10px">
      年月选择
    </span>
    <template v-if="yearMonth">
      <el-date-picker
        v-model="yearValue"
        type="month"
        :clearable="false"
        :picker-options="limitDate"
        placeholder="选择月"
        style="width: 120px"
      />
    </template>
    <template v-else>
      <el-select v-model="yearValue" size="small" placeholder="请选择">
        <el-option
          v-for="item in pickerOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { minYearDefault, hk6YearRange } from '@/utils/commonLib'
export default {
  name: 'YearPicker',
  model: {
    prop: 'dafaultvalue', // 绑定的值，通过父组件传递
    event: 'change' // 自定义时间名
  },
  props: {
    dafaultvalue: {
      type: String,
      default: dayjs().format('YYYY')
    },
    latestYear: {
      type: String,
      require: true,
      default: dayjs().format('YYYY')
    },
    yearMonth: {
      type: Boolean,
      dafault: false
    },
    yearData: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      mindate: new Date(this.minYear, 0, 1),
      limitDate: {
        disabledDate: (time) => {
          if (this.yearData.length) {
            const currentYear = this.yearData[0]
            const selectedYear = time.getFullYear()
            return selectedYear > currentYear || selectedYear < currentYear - 1
          }
          return time.getTime() < this.mindate.getTime()
        }
      }
    }
  },
  computed: {
    yearValue: {
      get: function() {
        return this.dafaultvalue
      },
      set: function(value) {
        if (!value) {
          value = dayjs().format('YYYY-MM')
          this.$emit('change', value?.toString())
          return
        }
        this.$emit('change', value?.toString())
      }
    },
    pickerOptions() {
      let minYear = new Date(this.minYear, 0, 1).getFullYear()
      let currentYear = new Date(this.latestYear).getFullYear()
      if (this.yearData.length) {
        minYear = this.yearData[1]
        currentYear = this.yearData[0]
      }
      const returnOptions = []
      for (let i = currentYear; i >= minYear; i--) {
        returnOptions.push({
          value: `${i}`,
          label: `${i}年`
        })
      }
      return returnOptions
    },
    isHK() {
      return this.$route.params.lottery_code === 'hk6'
    },
    minYear() {
      if (this.isHK) {
        return hk6YearRange()[hk6YearRange().length - 1] // 最早的年份
      }
      return minYearDefault
    }
  },
  mounted() {
    if (this.yearData.length <= 0) {
      this.$nextTick(() => {
        this.$emit('change', dayjs().format('YYYY'))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.year-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 10px 0;

  & /deep/ {
    .el-select {
      width: 100px;
    }
  }
}
</style>
